import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach token from localStorage fallback (mobile Safari sometimes drops third-party cookies)
api.interceptors.request.use((cfg) => {
  try {
    const t = typeof window !== "undefined" ? localStorage.getItem("oh_token") : null;
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  } catch (_) {}
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status !== 401) {
      console.warn("[api]", err?.config?.url, err?.response?.status, err?.message);
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (relative) => {
  if (!relative) return null;
  if (relative.startsWith("http")) return relative;
  return `${BACKEND}${relative}`;
};

export const formatNumber = (n) => (n || 0).toLocaleString("en-US");


// VOIHU launch analytics: attribute an entry to a campaign source.
// Recognised: instagram | tiktok | x | facebook | linkedin | qr | community | organic.
// Custom campaign slugs are also accepted.
const SOURCE_KEY = "voihu_src";
const SOURCE_TTL_MS = 1000 * 60 * 60 * 24 * 30; // 30 days
const SESSION_KEY = "voihu_sid";

const _normSource = (s) => {
  if (!s) return null;
  const v = String(s).toLowerCase().trim().slice(0, 40);
  return v || null;
};

const _sessionId = () => {
  if (typeof window === "undefined") return null;
  try {
    let sid = window.sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      const rnd = (crypto?.randomUUID?.() ||
                   `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      sid = `sid_${rnd}`;
      window.sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch (_) { return null; }
};

export const rememberCampaignSource = () => {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const src = _normSource(params.get("src") || params.get("utm_source"));
    if (src) {
      window.sessionStorage.setItem(SOURCE_KEY,
        JSON.stringify({ source: src, at: Date.now() }));
    }
  } catch (_) { /* ignore */ }
};

export const getCampaignSource = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(SOURCE_KEY);
    if (!raw) return null;
    const { source, at } = JSON.parse(raw);
    if (!source) return null;
    if (Date.now() - at > SOURCE_TTL_MS) {
      window.sessionStorage.removeItem(SOURCE_KEY);
      return null;
    }
    return source;
  } catch (_) { return null; }
};

export const trackEvent = (messageId, event, extra = {}) => {
  const source = extra.source || getCampaignSource();
  const ref = extra.ref;
  const session_id = _sessionId();
  api.post(`/messages/${messageId}/track`,
    { event, source, ref, session_id, country: extra.country || undefined })
    .catch(() => { /* privacy-safe: never block UX */ });
};

